import { MARQUEE_ITEMS } from "@/data";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section data-testid="marquee-section" className="bg-gold overflow-hidden py-5 border-y-4 border-navy">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-primary font-bold uppercase text-navy text-2xl md:text-4xl tracking-tight px-6">
              {item}
            </span>
            <span className="text-navy text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
